import React from "react";
import {FullscreenControl, Map as YandexMap, Polygon, YMaps, ZoomControl} from "@pbe/react-yandex-maps";
import {IDeliveryZoneDraft} from "../../models/settings/menu";
import {ZONE_FALLBACK_COLOR, zonesBounds} from "../../utils/deliveryZones/deliveryZones";

const YANDEX_MAPS_API = process.env.REACT_APP_YANDEX_API

interface IDeliveryZonesMap {
    zones: IDeliveryZoneDraft[]
    hint: (zone: IDeliveryZoneDraft) => string
}

/** Read-only preview of the zones. The settings form knows only these props, so the map provider can be swapped here. */
export function DeliveryZonesMap({zones, hint}: IDeliveryZonesMap) {
    return (
        <div style={{borderRadius: "4px", overflow: "hidden"}}>
            <YMaps query={{apikey: YANDEX_MAPS_API}}>
                {/* remounts, and so refits, when the set of zones changes; the API loads controls lazily, so they are components, not state strings */}
                <YandexMap key={zones.map((zone) => zone.id).join()}
                           defaultState={{center: [43.24, 76.92], zoom: 11, bounds: zonesBounds(zones), controls: []}}
                           style={{width: "100%", height: "360px"}}>
                    <ZoomControl/>
                    <FullscreenControl/>
                    {zones.map((zone) =>
                        <Polygon key={zone.id}
                                 modules={["geoObject.addon.hint"]}
                                 geometry={zone.polygon.map((ring) => ring.map(([lon, lat]) => [lat, lon]))}
                                 properties={{hintContent: hint(zone)}}
                                 options={{
                                     fillColor: zone.color || ZONE_FALLBACK_COLOR,
                                     fillOpacity: 0.35,
                                     strokeColor: zone.color || ZONE_FALLBACK_COLOR,
                                     strokeWidth: 2,
                                 }}/>
                    )}
                </YandexMap>
            </YMaps>
        </div>
    )
}
